import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import WebsiteBrief from "@/pages/WebsiteBrief";
import Admin from "@/pages/Admin";
import { PrivacyPolicy, TermsConditions, RefundPolicy } from "@/pages/Legal";
import { setLenis, scrollToSection } from "@/lib/scroll";

const BARE_ROUTES = ["/website-development-form", "/admin"];

const SiteChrome = () => {
  const { pathname } = useLocation();
  const bare = BARE_ROUTES.some((r) => pathname.startsWith(r));
  return (
    <>
      {!bare && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/website-development-form" element={<WebsiteBrief />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
      {!bare && <Footer />}
      {!bare && <WhatsAppFloat />}
    </>
  );
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = setTimeout(() => scrollToSection(id), 250);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App grain">
      <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true">
        <div className="absolute -left-40 -top-40 h-[520px] w-[520px] rounded-full bg-gradient-to-tr from-cyan-500/10 to-blue-600/10 blur-[120px]" />
        <div className="absolute -bottom-48 -right-40 h-[560px] w-[560px] rounded-full bg-gradient-to-tr from-cyan-500/10 to-blue-600/10 blur-[120px]" />
      </div>
      <BrowserRouter>
        <ScrollManager />
        <SiteChrome />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
